var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0002 21C25.1298 21 27.6668 18.4629 27.6668 15.3333C27.6668 12.2037 25.1298 9.66666 22.0002 9.66666C18.8705 9.66666 16.3335 12.2037 16.3335 15.3333C16.3335 18.4629 18.8705 21 22.0002 21Z",
    fill: "#7B7B7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3332 30.9167V32.3333C33.3332 32.7091 33.1839 33.0694 32.9182 33.3351C32.6526 33.6007 32.2922 33.75 31.9165 33.75H12.0832C11.7074 33.75 11.3471 33.6007 11.0814 33.3351C10.8158 33.0694 10.6665 32.7091 10.6665 32.3333V30.9167C10.6665 28.6623 11.562 26.5003 13.1561 24.9063C14.7502 23.3122 16.9122 22.4167 19.1665 22.4167H24.8332C27.0875 22.4167 29.2495 23.3122 30.8436 24.9063C32.4376 26.5003 33.3332 28.6623 33.3332 30.9167Z",
    fill: "#7B7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.31c051f8d4c51fb383ef447699c4d89b.svg";
export { ForwardRef as ReactComponent };